<template>
  <div class="popover-step-mover">
    <div class="header p-2 popover-title">
      <slot name="title"></slot>
    </div>
    <div
      v-if="
        localState === 'loading' ||
        localState === 'over' ||
        localState === 'over-removed' ||
        localState === 'quit'
      "
      class="user-guiding"
    >
      <div
        v-if="localState === 'loading'"
        class="flex justify-content-center w-100"
      >
        <font-awesome-icon
          :icon="['fal', 'spinner-third']"
          spin
          class="loader"
        />
      </div>
      <div
        v-else-if="localState === 'over' || localState === 'over-removed'"
        class="flex justify-content-center align-items-center w-100 flex-column"
      >
        <font-awesome-icon :icon="['fal', 'check']" class="loader" />
        <div class="state-explanation mt-3">
          <slot name="state-over"></slot>
        </div>
      </div>
      <div
        v-else-if="localState === 'quit'"
        class="flex justify-content-center align-items-center w-100 flex-column"
      >
        <font-awesome-icon
          :icon="['fal', 'exclamation-triangle']"
          class="quit"
        />
        <div class="state-explanation mt-3 mx-5 text-center bold">
          <slot name="state-cancel"></slot>
        </div>
        <div class="quit-buttons mx-2 mt-3">
          <el-button
            @click="cancelQuit()"
            plain
            size="mini"
            class="cancel-button"
          >
            <slot name="state-cancel-button-keep-going"></slot>
          </el-button>
          <el-button @click="close()" type="danger" size="mini">
            <slot name="state-cancel-button-quit"></slot>
          </el-button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="method-picker mt-2 w-100 px-2">
        <el-radio-group
          v-model="method"
          size="mini"
          class="w-100 d-flex align-items-center justify-content-center"
          @change="$emit('methodChange', $event)"
        >
          <el-radio-button
            v-for="button in radioButtons"
            :key="button.label"
            :label="button.label"
            class="w-50"
          >
            {{ $t(button.title) }}</el-radio-button
          >
        </el-radio-group>
      </div>
      <slot name="popover-content"></slot>
      <slot name="validation-buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popover-child-options',
  props: {
    radioButtons: {
      type: Array,
      default: () => [],
    },
    state: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      method: this.radioButtons[0].label,
      localState: this.state,
    };
  },
  methods: {
    close() {
      this.$emit('close');
      this.localState = '';
    },
    cancelQuit() {
      this.$emit('cancel-quit');
      this.localState = '';
    },
  },
  watch: {
    state() {
      this.localState = this.state;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-color: $grey-1-mayday;
  border-bottom: 2px solid $grey-4-mayday;
  font-weight: bold;
}

:deep() .el-radio-button__inner {
  width: 100% !important;
  background-color: rgba($blue-mayday, 0.1);
  border-color: $blue-mayday !important;
}

.user-guiding {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader {
  width: 32px;
  height: 32px;
  color: $blue-mayday;
}

.quit {
  width: 32px;
  height: 32px;
  color: $red-mayday;
}

.cancel-button {
  background-color: $grey-2-mayday;
  border: none;
  &:hover {
    color: $blue-mayday !important;
    background-color: $grey-2-mayday !important;
    border: none;
  }
}
</style>
